import type { ReactNode } from 'react';

import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { useAuth } from '@pesto/features';
import { Route } from 'react-router-dom';

import { ProtectedRoute } from '../components/ProtectedRoute';
import { routes } from '../constants/routes';
import { PartnerApplicationLayout } from '../layouts/PartnerApplicationLayout';
import { CardDetailsPage } from '../pages/CardDetails/CardDetailsPage';
import { Cards } from '../pages/Cards/Cards';
import { Dashboard } from '../pages/Dashboard/Dashboard';
import { LoanData } from '../pages/LoanData/LoanData';
import { LoanDetailsPage } from '../pages/LoanDetails/LoanDetailsPage';
import { Loans } from '../pages/Loans/Loans';
import { Login } from '../pages/Login';
import LoginCallback from '../pages/LoginCallback';
import { NotFound } from '../pages/NotFound';
import { UserDetailsPage } from '../pages/UserDetails/UserDetailsPage';
import { Users } from '../pages/Users/Users';

const AppRoutesProvider = ({ children }: { children: ReactNode }) => {
  return <PartnerApplicationLayout>{children}</PartnerApplicationLayout>;
};

export const RouterProvider = () => {
  const { isAuthenticated } = useAuth();

  return (
    <AppRoutesProvider>
      <Routes>
        <Route index element={<Login />} />
        <Route path={routes.loginCallback} element={<LoginCallback />} />
        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated()} />}>
          <Route path={routes.dashboard} element={<Dashboard />} />
          <Route path={routes.users} element={<Users />} />
          <Route path={routes.userDetails} element={<UserDetailsPage />} />
          <Route path={routes.loans} element={<Loans />} />
          <Route path={routes.loanDetails} element={<LoanDetailsPage />} />
          <Route path={routes.cards} element={<Cards />} />
          <Route path={routes.cardDetails} element={<CardDetailsPage />} />
          <Route path={routes.loanData} element={<LoanData />} />
        </Route>
        <Route path={routes.notFound} element={<NotFound />} />
      </Routes>
    </AppRoutesProvider>
  );
};
